const NotValidLink = () => {
  return (
    <div>
      <p className="text-xl font-semibold">Link non valido</p>
      <p>Questo link non è valido, potrebbe essere scaduto o errato.</p>
      <p>Contattare l&apos;assistenza in caso di problemi con l&apos;accesso.</p>
    </div>
  );
};

export default NotValidLink;
